export default "__VITE_ASSET__C9kCazqt__"